import {z} from "zod/v4-mini"
import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {AddressMode, dataObjectReference, float32Array, uint32Array} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/basic-definitions"
import {descriptorDefinition} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/image-op-descriptor"
import {imageOpHalOptions} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/hal/image-op-hal-types"

export const topology = z.literal("triangleList")

export const geometry = z.object({
    topology: topology,
    vertices: z.object({
        positions: float32Array, // in pixel space
        uvs: z.optional(float32Array), // in pixel space; default: {x: 0, y: 0}
        colors: z.optional(float32Array), // default: {r: 1, g: 1, b: 1, a: 1}
    }),
    indices: z.optional(uint32Array), // default: [0, 1, 2, 3, 4, 5, ...]
})

export type Geometry = z.infer<typeof geometry>

export const definition = {
    validation: {
        returns: anyImageOpResult,
        parameters: z.object({
            imageOpHalOptions: imageOpHalOptions,

            geometry: z.union([geometry, dataObjectReference]),
            // worldTransform: matrix3x2Like.optional(),
            textureImage: z.optional(anyImageOpResult),
            addressMode: z._default(AddressMode, "clamp"),
            descriptor: descriptorDefinition,
        }),
    },
}
